var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessoOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_973_39707)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FF882F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8821 7.33398H16.8542C16.7101 7.33398 16.5733 7.39922 16.4851 7.51084L10.4221 15.0822L7.51488 11.4509C7.4709 11.3958 7.41485 11.3513 7.35092 11.3207C7.28699 11.2901 7.21686 11.2741 7.14578 11.274H6.11788C6.01935 11.274 5.96495 11.3857 6.02524 11.461L10.053 16.4912C10.2412 16.726 10.603 16.726 10.7927 16.4912L17.9748 7.51953C18.0351 7.4456 17.9806 7.33398 17.8821 7.33398Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_973_39707"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessoOrange);
export default __webpack_public_path__ + "static/media/successoOrange.dd686e90d592baf84c9997f1b4ba9126.svg";
export { ForwardRef as ReactComponent };